<template>
  <div id="app" class="oldUI" :key="themeKey">
    <div id="mainBlock" v-if="$route.path!='/login'">
      <router-view />
    </div>
     <div v-else>
      <router-view />
    </div>
    <div id="appCopyright">
      {{ copyright }} 
      <span id="systemVersion">版本：{{$store.state.app.systemVersion}}</span>
    </div>
      <theme-picker style="display:none"
      ref="themePicker"
    />
  </div>
</template>

<script>
import Watermark from "./utils/watermark";
import { systemInfoByIP } from "./utils/index.js";
import ThemePicker from "@/components/ThemePicker";
export default {
  name: "App",
  components: { ThemePicker },
  data() {
    return {
      themeKey: 3,
      themeID:''
    };
  },
  created() {
    if(location.href.split('ThemeID').length==3){
      this.themeID=location.href.split('ThemeID')[1]
    }else{
      this.themeID = systemInfoByIP().themeID
    }
    localStorage.setItem('ruleWeb_ThemeID',this.themeID)
    this.utils.setStore("lanuage", "zh");
    this.getModuleTypes();
  },
  computed: {
    copyright() {
      return systemInfoByIP().copyright;
    },
  },
  watch: {
    $route(route) {
      if (!localStorage.getItem("risk_component_type")) {
        this.getModuleTypes();
      }
      setTimeout(() => {
        if (localStorage.useWaterMark == 1) Watermark.set("二十六度数科");
      }, 500);
    },
  },
  mounted() {
    if (localStorage.useWaterMark === 1) Watermark.set("二十六度数科");
    // 设置主题
    const set = (ThemeData) => {
      const { mainBg, siderBar, siderBarFontC, lableC, loginBg } = ThemeData;
      document.documentElement.style.setProperty("--mainBg", mainBg);
      document.documentElement.style.setProperty("--siderBar", siderBar);
      document.documentElement.style.setProperty( "--siderBarFontC", siderBarFontC);
      document.documentElement.style.setProperty("--lableC", lableC);
      document.documentElement.style.setProperty("--loginBg", loginBg);
      //siderBar要用十六进制
      this.$refs.themePicker.changeTheme(siderBar);
      this.$store.dispatch("settings/changeSetting", {
        key: "theme",
        value: siderBar,
      });
    };
      const themeData = this.$store.state.settings.themeOptions[this.themeID];
      if(themeData) set(themeData);
  },
  methods: {
    getModuleTypes() {
      if (this.$route.path === "/login" || this.$route.path === "/") {
        return;
      }
      this.request({
        url: "/admin/dict/qryDictByNames",
        method: "get",
      }).then((res) => {
        const data = res.data;
        for (let key in data) {
          localStorage.setItem(key, JSON.stringify(data[key]));
        }
      });
    },
  },
};
</script>

<style lang="scss">
:root {
  --mainBg: #F3F8FD; /*右边mainBox底色*/
  --siderBar: #2e43ae; /*左边菜单底色，tag底色*/
  --siderBarFontC: #adbbff; /*左边菜单未选颜色*/
  --lableC: #0e2e5f; /*登录时label色，右边顶部面包屑字体颜色，tag色*/
  --loginBg: #7199EF; /*整页渐变底色*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue